import { Grid, Box } from "@mui/material";
import { Link } from "react-router-dom";
import useTracking from "../hooks/useTracking";

const Secondimage = () => {

  const { ref, handleClick } = useTracking("Secondimage");
  return (
    

    <Box ref={ref} sx={{ width: "100%", overflow: "hidden", }}>
      <Grid container spacing={2} sx={{padding:"20px 20px 0px 20px",}}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Link to="/partner"     onClick={() => handleClick("left_banner_clicked")}>
            <Box
              component="img"
              src="/img1/left.png"
              alt="First"
              sx={{
                width: "100%",
                height: { xs: 190, sm: 300, md: 400 },
                borderRadius: 2,
                cursor: "pointer",
              }}
            />
          </Link>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Link to="/amazon-shop" onClick={() => handleClick("right_banner_clicked")}>
            <Box
              component="img"
              src="/img1/right.png"
              alt="Second"
              sx={{
                width: "100%",
                height: { xs: 190, sm: 300, md: 400 },
                borderRadius: 2,
                cursor: "pointer",
              }}
            />
          </Link>
        </Grid>
      </Grid>

    </Box>

   

  );
};

export default Secondimage;